import { BAMBOU_LIST_FAIL, BAMBOU_LIST_REQUEST, BAMBOU_LIST_SUCCESS, BAMBOU_LIST_UPDATE } from "../constats/bambou.constant";

export const bambouListReducer = (state={}, action) => {
    switch (action.type) {
        case BAMBOU_LIST_REQUEST:
            return {
                loading: true
            };
        case BAMBOU_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case BAMBOU_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        case BAMBOU_LIST_UPDATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    data: state.data.data.map(element =>
                        element.id === action.payload.id ? { ...action.payload } : element
                    )
                }
            };
        default:
            return state;
    }
}